import React, { useState } from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import Images from "../images";
import axiosInstance from "../Help/AxiosLogicInstance";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import useAuth from ".././hook/useAuth";
import ResetPasswordModal from "./ResetPassword";

import Signup from "./Signup";
const SignIn = ({
  show,
  handleClose,
  from,
  onLoginSuccess,
  openSignUp,
  openReset,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, loading } = useAuth();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [form, setForm] = useState({ Email: "", Password: "" });
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showPasswordExpiredNote, setShowPasswordExpiredNote] = useState(false);
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });
  // const [showResetModal, setShowResetModal] = useState(false);
  // const [showSignIn, setShowSignIn] = useState(false);
  // const [showReset, setShowReset] = useState(false);

  // const handleResetPassword = (e) => {
  //   e.preventDefault();
  //   setShowResetModal(true);
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setShowPasswordExpiredNote(false); // Reset the note
    try {
      const response = await axiosInstance.post("/api/Student/StudentLogin", {
        Email: form.Email,
        Password: form.Password,
      });
      if (response.data?.Result?.Token) {
        localStorage.setItem("token", response.data.Result.Token);
        localStorage.setItem("StudentId", response.data.Result.StudentId);
        toast.success("Login successful!");
        const redirectPath = from || "/";
        navigate(redirectPath);
        if (onLoginSuccess) onLoginSuccess();
        handleClose();
        window.location.reload();
      } else {
        setError("Invalid response from server");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const { Status, Message } = error.response.data;
        if (Status === "400" && Message === "Your Old password is expired. Please reset and Proceed") {
          toast.error(Message);
          setError(Message);
          setShowPasswordExpiredNote(true);
        } else {
          setError(Message || "Invalid email or password");
        }
      } else {
        setError("Invalid email or password");
      }
    }
  };
  // Open Reset Password modal
  // const handleForgotPassword = (e) => {
  //   e.preventDefault();
  //   handleClose(); // close SignIn modal
  //   setTimeout(() => {
  //     setShowReset(true); // open Reset modal after SignIn fully closes
  //   }, 200);
  // };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      centered
      scrollable
      className="signup-modal"
      backdrop="static"
      keyboard={true}
    >
      <Modal.Body className="p-0 signup-body">
        <div className="signup-container">
          {/* Left Image */}
          <div className="signup-left d-none d-lg-block">
            <img src={Images.Signup} alt="Signup" className="signup-bg" />
            <h1 className="signup-heading">
              Welcome, We are glad to see you again!
            </h1>
          </div>

          {/* Right Form */}
          <div className="signup-right signin-padding ">
            {/* Close Button */}
            <button onClick={handleClose} className="close-btn">
              &times;
            </button>

            {/* Stepper Titles */}
            <div className="stepper-titles text-center mb-1">
              <div className="title-main">Sign In To Your Account</div>
            </div>

            {/* Scrollable Form */}
            <div className="">
              <Form onSubmit={handleSubmit} className="signin-form signin-form">
                {showPasswordExpiredNote && (
                  <div className="alert alert-warning mb-2">
                    <strong>Note:</strong> Your old password has expired. Please reset your password to proceed.
                  </div>
                )}
                <Form.Group className="mb-2">
                  <Form.Label className="signup-form-label form-label">
                    Email <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="Email"
                    value={form.Email}
                    onChange={handleChange}
                    className="input-box"
                    placeholder="Enter your email"
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-2 position-relative">
                  <Form.Label className="signup-form-label form-label">
                    Password <span className="text-danger">*</span>
                  </Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      type={passwordVisible ? "text" : "password"}
                      name="Password"
                      value={form.Password}
                      onChange={handleChange}
                      placeholder="Enter your password"
                      required
                      className="input-box pe-5"
                    />
                    <i
                      className={`fa ${
                        passwordVisible ? "fa-eye-slash" : "fa-eye"
                      } password-toggle-icon extra-class eye-icon`}
                      onClick={() => setPasswordVisible(!passwordVisible)}
                    ></i>
                  </div>
                </Form.Group>

                <div className="text-end mb-2">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleClose(); // closes SignIn
                      if (typeof openReset === "function") {
                        openReset(); // sets activeModal = "reset"
                      }
                    }}
                    className="text-success text-decoration-none fw-semibold"
                  >
                    Forgot Password?
                  </a>
                </div>

                {error && <div className="text-danger mb-2">{error}</div>}

                <Button
                  type="submit"
                  variant="success"
                  className="btn mt-2 w-20"
                >
                  Sign In
                </Button>

                <div className="text-start mt-2">
                  Not a member?{" "}
                  <a
                    href="#"
                    className="text-success fw-semibold"
                    onClick={(e) => {
                      e.preventDefault();
                      handleClose(); // close SignIn
                      openSignUp(); // open SignUp (from parent)
                    }}
                  >
                    Sign Up
                  </a>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SignIn;
